import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage/LoginPage";
import Dashboard from "./components/dashboard/Dashboard";
import DiagramsPage from "./pages/DiagramsFullScreen/DiagramsPage";
import RequireAuth from "./features/auth/RequireAuth";
import DiagramsFullScreen from "./pages/DiagramsFullScreen/DiagramsFullScreen";

function App() {
  return (
    // <BrowserRouter>
    //   <Routes>
    //     <Route path="/" element={<LoginPage />} />
    //     <Route path="/home" element={<Navigate to="/home/orders" />} />
    //     <Route path="/home/*" element={<Dashboard />}>
    //       {AppRoutes.map((route, i) => {
    //         const { index, element } = route;
    //         return <Route key={i} path={index} element={element} />;
    //       })}
    //     </Route>
    //     <Route path="/diagrams-full-screen" element={<DiagramsPage />} />
    //   </Routes>
    // </BrowserRouter>

    <Routes>
      <Route path="/" element={<Layout />}>
        {/* public routes */}
        <Route index element={<LoginPage />} />
        <Route path="login" element={<LoginPage />} />

        {/* protected routes */}
        <Route element={<RequireAuth />}>
          <Route
            path="/diagrams-full-screen"
            element={<DiagramsFullScreen />}
          />
          <Route path="/home" element={<Navigate to="/home/orders" />} />
          <Route path="/home/*" element={<Dashboard />}>
            {AppRoutes.map((route, i) => {
              const { index, element } = route;
              return <Route key={i} path={index} element={element} />;
            })}
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
